// extracted by mini-css-extract-plugin
module.exports = {"iconCheck":"styles_iconCheck__2poMk","error":"styles_error__28lOA","correct":"styles_correct__prAYB","question":"styles_question__t7HFe"};